import chatProxyWsConnection from './chatProxyWsConnection';
import chatChannelProvider from '../chatChannelProvider';
import { ChatListener, ChatListenerCallbacks } from '../interface';

type CustomerInfo = {
  readonly customerId: number;
  readonly customerUuid: string;
};

class ChatWebsocketManager {
  private readonly chatListeners: ChatListener[];

  constructor() {
    this.chatListeners = chatChannelProvider.all()
      .map(chatChannel => chatChannel.listener);
  }

  openConnection({ customerUuid }: CustomerInfo): void {
    

    chatProxyWsConnection.open(customerUuid);
  }

  closeConnection(): void {
    

    chatProxyWsConnection.close();
  }

  registerListeners(callbacks: ChatListenerCallbacks): void {
    this.chatListeners.forEach(listener => listener.register(callbacks));

    
  }

  unregisterListeners(): void {
    this.chatListeners.forEach(listener => listener.unregister());

    
  }
}

const chatWebsocketManager = new ChatWebsocketManager();

export default chatWebsocketManager;
